/* Bronson footer: mobile accordions + back to top */
(() => {
  const init = () => {
    document.querySelectorAll('[data-footer-accordion]').forEach((group) => {
      if (group.dataset.bound) return;
      group.dataset.bound = 'true';
      const toggle = group.querySelector('[data-footer-toggle]');
      toggle?.addEventListener('click', () => {
        const open = !group.classList.contains('is-open');
        group.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open);
      });
    });

    const top = document.querySelector('[data-back-to-top]');
    if (top && !top.dataset.bound) {
      top.dataset.bound = 'true';
      const update = () => top.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.75);
      window.addEventListener('scroll', update, { passive: true });
      update();
      top.querySelector('button').addEventListener('click', () => {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
